import { DesignBurdenParams } from "@app/models/chart-data.model";
import { putPromise } from "./request-promise";

export function updateDesignBurdens(designBurdenParams:DesignBurdenParams) {
	return putPromise(
		'api/dashboards/highchart_analytics/add_design_burden',
		designBurdenParams,
		(data) => data || null
	);
}